module.exports = __webpack_public_path__ + "static/media/TITAN Supplier Manual_Sept-2020_EN_vf.db11c2a9.pdf";